module.exports = __webpack_public_path__ + "img/n2.930cd99e.png";